


































import { Component, Prop, Vue } from 'vue-property-decorator';
import SignaturePad from '@signing-page/signing/draw/components/SignaturePad.vue';
import { EButtonTypes } from '@/enums/ButtonType';
import Button from '@/components/Button.vue';

@Component({
  components: {
    SignaturePad,
    Button,
  },
  data: () => ({
    EButtonTypes,
  }),
})
export default class DrawSignature extends Vue {
  @Prop() landscapeMode: boolean;
  @Prop() signActionText: string;

  signatureData: { signatureBase30: string; signatureBase64: string } = null;

  get hasSignature(): boolean {
    return !!this.signatureData?.signatureBase30 && !!this.signatureData?.signatureBase64;
  }

  handleSignature(payload: { signatureBase30: string; signatureBase64: string }) {
    this.signatureData = payload;
    this.$emit('signature', payload);
  }

  handleReset() {
    this.signatureData = null;
    this.$emit('reset');
  }

  handleCancel() {
    this.$emit('cancel');
  }

  handleSign() {
    this.$emit('sign');
  }
}
